import DefaultLandSelection from "src/components/feature/ProjectDetailView/Forms/LandParcelSelection";

const LandParcelSelection = () => {
  return <DefaultLandSelection />;
};

export default LandParcelSelection;
